import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Login from "@/pages/Login";

import UnidadeLayout from "@/pages/UnidadeLayout";
import NovaVenda from "@/pages/unidade/NovaVenda";
import Estoque from "@/pages/unidade/Estoque";
import Historico from "@/pages/unidade/Historico";
import Clientes from "@/pages/unidade/Clientes";

import MasterLayout from "@/pages/MasterLayout";
import MasterDashboard from "@/pages/master/MasterDashboard";
import EstoqueMaster from "@/pages/master/EstoqueMaster";
import MovimentacoesEstoque from "@/pages/master/MovimentacoesEstoque";
import VendedoresMaster from "@/pages/master/VendedoresMaster";
import ClientesMaster from "@/pages/master/ClientesMaster";
import Configuracoes from "@/pages/master/Configuracoes";
import Performance from "@/pages/master/Performance";
import Retencao from "@/pages/master/Retencao";
import Backup from "@/pages/master/Backup";
import MetasMaster from "@/pages/master/MetasMaster";
import MetasUnidade from "@/pages/unidade/MetasUnidade";
import RankingUnidade from "@/pages/unidade/RankingUnidade";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: {
              fontFamily: "'IBM Plex Sans', sans-serif",
              borderRadius: "0px",
              border: "2px solid #0a0a0a",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/unidade/:slug" element={<UnidadeLayout />}>
            <Route index element={<NovaVenda />} />
            <Route path="estoque" element={<Estoque />} />
            <Route path="historico" element={<Historico />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="metas" element={<MetasUnidade />} />
            <Route path="ranking" element={<RankingUnidade />} />
          </Route>

          <Route path="/master" element={<MasterLayout />}>
            <Route index element={<MasterDashboard />} />
            <Route path="produtos" element={<Navigate to="/master/estoque" replace />} />
            <Route path="estoque" element={<EstoqueMaster />} />
            <Route path="movimentacoes" element={<MovimentacoesEstoque />} />
            <Route path="vendedores" element={<VendedoresMaster />} />
            <Route path="clientes" element={<ClientesMaster />} />
            <Route path="performance" element={<Performance />} />
            <Route path="retencao" element={<Retencao />} />
            <Route path="metas" element={<MetasMaster />} />
            <Route path="backup" element={<Backup />} />
            <Route path="configuracoes" element={<Configuracoes />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
